<p-dialog
    appDialogoPadrao="pi pi-comment"
    descricao="E-mail para o contato selecionado."
    [visible]="visible()"
    (visibleChange)="visible.set($event)"
    header="Enviar Mensagem"
    [dismissableMask]="true"
    [breakpoints]="{ '1200px': '50vw', '960px': '70vw', '640px': '90vw' }"
    [maximizable]="true"
    [style]="{ width: '45rem' }"
    (onHide)="onCancel()"
>
    <div class="email-form">
        <div class="field">
            <label for="to" class="field-label">Destinatário</label>
            <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-user"></p-inputIcon>
                <input pInputText id="to" type="text" [(ngModel)]="emailData.to" placeholder="Digite o email do destinatário" class="w-full" />
            </p-iconField>
        </div>

        <div class="field">
            <label for="subject" class="field-label">Assunto</label>
            <p-iconField iconPosition="left">
                <p-inputIcon styleClass="pi pi-pencil"></p-inputIcon>
                <input pInputText id="subject" type="text" [(ngModel)]="emailData.subject" placeholder="Digite o assunto do email" class="w-full" />
            </p-iconField>
        </div>

        <div class="field">
            <label for="attachments" class="field-label">Anexos</label>
            <input #fileInput id="attachments" type="file" multiple (change)="onFilesSelected($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.txt" hidden />
            <button type="button" pButton pRipple label="Escolher Arquivos" icon="pi pi-paperclip" class="p-button-outlined" (click)="fileInput.click()"></button>
            @if (emailData.attachments?.length) {
                <div class="attachments-list">
                    @for (file of emailData.attachments; track file; let i = $index) {
                        <div class="attachment-item">
                            <span class="attachment-name">{{ file.name }}</span>
                            <span class="attachment-size">({{ file.size / 1024 | number: '1.0-0' }} KB)</span>
                            <button type="button" pButton icon="pi pi-times" class="p-button-text p-button-danger" (click)="removeAttachment(i)" aria-label="Remover"></button>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="field editor-field">
            <!--            <label class="field-label">Mensagem complementar</label>-->
            <p-editor [(ngModel)]="mensagemUsuario" (ngModelChange)="onConteudoAlterado()" [style]="{ height: '320px' }" placeholder="Escreva sua mensagem aqui...">
                <ng-template pTemplate="header">
                    <span class="ql-formats">
                        <button class="ql-bold" aria-label="Negrito"></button>
                        <button class="ql-italic" aria-label="Italico"></button>
                        <button class="ql-underline" aria-label="Sublinhar"></button>
                    </span>
                    <span class="ql-formats">
                        <select class="ql-color"></select>
                        <select class="ql-background"></select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered" aria-label="Lista ordenada"></button>
                        <button class="ql-list" value="bullet" aria-label="Lista com marcadores"></button>
                    </span>
                    <span class="ql-formats">
                        <select class="ql-align"></select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-link" aria-label="Link"></button>
                        <button class="ql-image" aria-label="Imagem"></button>
                    </span>
                </ng-template>
            </p-editor>
            <div class="preview-trigger">
                <button type="button" pButton pRipple label="Pre-visualização" icon="pi pi-eye" class="p-button-outlined p-button-sm" (click)="onVisualizar()"></button>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="actions">
            <button type="button" pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-secondary cancel-button" (click)="onCancel()"></button>
            <button type="button" pButton pRipple label="Enviar" icon="pi pi-send" class="p-button send-button" (click)="onSendMessage()" [disabled]="!isFormValid()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-envelope"
    descricao="Como a mensagem chegará ao destinatário."
    [(visible)]="exibirDialogPreview"
    header="Pre-visualização do email"
    [dismissableMask]="true"
    [maximizable]="true"
    [breakpoints]="{ '1200px': '80vw', '960px': '92vw', '640px': '96vw' }"
    [style]="{ width: '85vw' }"
>
    <iframe class="preview-dialog-iframe" [src]="previewUrl" sandbox="allow-popups allow-popups-to-escape-sandbox"></iframe>
</p-dialog>
